var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/facets/category-facets-filter-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg class=\"c-facets-link-small__svg\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 13\" role=\"img\" aria-hidden=\"true\">\n    <style>\n        .category-facets-filter-icon-cls-1 { fill: #05728c; }\n    </style>\n    <path class=\"category-facets-filter-icon-cls-1\" d=\"M3.51,5.36V0H2.2V5.36a2.81,2.81,0,0,0,0,5.47V13H3.51V10.83a2.81,2.81,0,0,0,0-5.47ZM2.85,9.61A1.52,1.52,0,1,1,4.38,8.1,1.53,1.53,0,0,1,2.85,9.61Z\"/>\n    <path class=\"category-facets-filter-icon-cls-1\" d=\"M12.23,1.9V0H10.92V1.9a2.8,2.8,0,0,0,0,5.46V13h1.31V7.36a2.8,2.8,0,0,0,0-5.46Zm-.65,4.25a1.52,1.52,0,1,1,1.53-1.52A1.53,1.53,0,0,1,11.58,6.15Z\"/>\n    <path class=\"category-facets-filter-icon-cls-1\" d=\"M20.83,5.36V0H19.52V5.36a2.81,2.81,0,0,0,0,5.47V13h1.31V10.83a2.8,2.8,0,0,0,0-5.47Zm-.65,4.25A1.52,1.52,0,1,1,21.71,8.1,1.53,1.53,0,0,1,20.18,9.61Z\"/>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/facets/category-facets-filter-icon.j2"] , dependencies)